/* Styling and images */
import './MainLayout.scss';

/* Dependencies */
import { Outlet } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";

export default function MainLayout() {
  return (
    <>
      <Header></Header>
      
      <div className="content-area">
        <Outlet />
      </div>

      <Footer></Footer>

      <div id="to-top" className="to-top"><i className="fa fa-angle-up"></i></div>
    </>
  );
}
